/* Make Your Cart Go — scroll-reveal animations.
   Adds .mycg-reveal only to elements currently below the fold, then
   reveals them (.mycg-in) as they scroll into view. Elements already in
   view on load are left untouched (no flash, no hidden content). */
(function () {
  if (
    !('IntersectionObserver' in window) ||
    (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
  ) {
    return;
  }

  var SELECTOR = [
    '.mycg-steps__head', '.mycg-step',
    '.mycg-featured__card',
    '.mycg-motorize__box',
    '.mycg-split__grid > *',
    '.mycg-testimonials__title', '.mycg-testimonials .mycg-quote',
    '.mycg-fleetdemo__grid > *',
    '.mycg-finalcta__title', '.mycg-finalcta .mycg-cta',
    '.mycg-includes .mycg-eyebrow-mono', '.mycg-includes .mycg-h', '.mycg-inc',
    '.mycg-specs__grid > *',
    '.mycg-video__inner',
    '.mycg-spec-ticker__item',
    '.mycg-band__inner',
    '.card-wrapper',
    '.rich-text__blocks', '.image-with-text__content'
  ].join(',');

  function init() {
    var els = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mycg-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    var vh = window.innerHeight || document.documentElement.clientHeight || 800;

    els.forEach(function (el) {
      // Leave anything already on screen visible — only animate what's below.
      if (el.getBoundingClientRect().top < vh * 0.92) return;
      var parent = el.parentElement;
      var idx = parent ? Array.prototype.indexOf.call(parent.children, el) : 0;
      el.style.transitionDelay = ((idx % 4) * 70) + 'ms';
      el.classList.add('mycg-reveal');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Mobile drawer close button → run Dawn's proper close (focus restore +
   body-scroll unlock) via a synthetic summary click. Capture phase +
   stopImmediatePropagation so Dawn's duplicate button binding does not also
   fire. Separate IIFE so the reduced-motion early-return above never skips it. */
(function () {
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('.mycg-mdrawer__close');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var container = btn.closest('.menu-drawer-container');
      var summary = container && container.querySelector('summary');
      if (summary) summary.click();
    },
    true
  );
})();
